import { useMeasure } from 'react-use';

import { useIsMobile } from '#src/hooks/device/useIsMobile.ts';

const itemWidth = 185;
const doubleUnitGap = 16;

export const useContainerCardsPerPage = <T extends HTMLElement>() => {
  const [ref, { width }] = useMeasure<T>();
  const isMobile = useIsMobile();

  if (isMobile) {
    return [ref, 20] as const;
  }

  // figure out how many cards per row we can fit
  const nbPerRow = Math.floor(
    (width + doubleUnitGap) / (itemWidth + doubleUnitGap)
  );
  if (nbPerRow === 0) {
    return [ref, 20] as const;
  }

  // target 40 cards per page
  const nbcols = Math.round(40 / nbPerRow);
  const computedNumber = nbPerRow * nbcols;

  return [ref, computedNumber] as const;
};
